module.exports = __webpack_public_path__ + "static/media/sakshee.6ba2229f.jpeg";